import { render, staticRenderFns } from "./AnimatedIcon.vue?vue&type=template&id=33782522&scoped=true&"
import script from "./AnimatedIcon.vue?vue&type=script&lang=js&"
export * from "./AnimatedIcon.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedIcon.vue?vue&type=style&index=0&id=33782522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33782522",
  null
  
)

export default component.exports